import { observer } from 'mobx-react';
import { ChangeEvent, FC, ReactElement } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { localeStore } from '~/mobx/localesStore';
import Textarea from '~/view/components/Controls/Textarea/Textarea';
import './style.scss';

const ProductNotes: FC = observer((): ReactElement => {
  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    orderProductModalStore.onChangeNotes(event.target.value);
  };

  return (
    <div className="product-notes">
      <h3 className="product-notes__title">{localeStore.t('Notes')}</h3>
      <Textarea
        value={orderProductModalStore.product?.notes}
        onChange={onChange}
        placeholder={localeStore.t('write_a_note')}
        loading={!orderProductModalStore.product}
        maxLength={160}
      />
    </div>
  );
});

export default ProductNotes;
